let language = {
    SHOPIFY_CONNECT_ALREADY_HAVE_ACCOUNT: "您已经有一个账户。继续使用您的",
    SHOPIFY_CONNECT_USER_EMAIL: "{{userMail}}",
    SHOPIFY_CONNECT_CONTINUE_BTN: "继续",
    SHOPIFY_CONNECT_CONNECT_TO_SHOPIFY_TEXT: "将 {{appName}} 连接到 Shopify",
    SHOPIFY_CONNECT_NEW_TO_SITE_TEXT: "首次使用 {{appName}} ?",
    SHOPIFY_CONNECT_SIGNUP_LINK: "注册",
    SHOPIFY_CONNECT_ALREADY_HAVA_ACCOUNT_QUESTION_TEXT: "已经有账户？",
    SHOPIFY_CONNECT_SIGNIN_LINK: "登录",
    SHOPIFY_CONNECT_CONFIRM_CONNECTION_TEXT: "确认连接",
    SHOPIFY_CONNECT_CONNECT_STORE_TO_USER_TEXT: "将商店连接到 {{userMail}}",
    SHOPIFY_CONNECT_SIGNIN_DIFFERENT_ACCOUNT: "用不同的账户登录",
};

export { language }
